import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { IconsModule, icoCloudUpload, icoTickCircleDuo, icoWarningDuo } from '../icons';
import { LinkModule } from '../link';
import { SafeUrlModule } from '../safe-url';
import { DescribeFileExtensionPipe } from './describe-file-extension.pipe';
import { FileSelectComponent } from './file-select/file-select.component';
import { SmallImageSelectComponent } from './small-image-select/small-image-select.component';

@NgModule({
  declarations: [DescribeFileExtensionPipe, FileSelectComponent, SmallImageSelectComponent],
  imports: [
    CommonModule,
    LinkModule,
    IconsModule.withIcons(icoCloudUpload, icoTickCircleDuo, icoWarningDuo),
    RouterModule,
    SafeUrlModule,
    TranslocoModule,
    TranslocoMarkupModule
  ],
  exports: [FileSelectComponent, SmallImageSelectComponent]
})
export class FileSelectModule {}
